import api from "@/services/api";
import { CustomExtension, CustomExtensionExistsDto } from "@/services/customExtensions/types";
import { AclMember } from "@/services/security/types";

export async function getExtensionsByAccess(): Promise<Array<CustomExtension>> {
    return new Promise((resolve, reject) => {
        api.get("/CustomExtensions/GetByAccess").then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}

export async function getExtension(id: string): Promise<CustomExtension> {
    return new Promise((resolve, reject) => {
        api.get(`/CustomExtensions/${id}`).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}

export async function getExtensionInfo(id: string): Promise<CustomExtension> {
    return new Promise((resolve, reject) => {
        api.get(`/CustomExtensions/info/${id}`).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}

export function createExtension(extension: CustomExtension) : Promise<string> {
    return new Promise((resolve, reject) => {
        api.post(`/CustomExtensions`, extension).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}

export function updateExtension(extension: CustomExtension) : Promise<void> {
    return new Promise((resolve, reject) => {
        api.put(`/CustomExtensions`, extension).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}

export function deleteExtension(id: string): Promise<any> {
    return new Promise((resolve, reject) => {
        api.delete(`/CustomExtensions/${id}`).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}

export async function getAcl(id: string): Promise<AclMember[]> {
    return new Promise((resolve, reject) => {
        api.get(`/acl/customExtension/${id}`).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}

export async function checkIfExtensionExists(name: string, entityId: string): Promise<boolean> {
    const model = {
        name: name,
        entityId: entityId
    } as CustomExtensionExistsDto;

    return new Promise((resolve, reject) => {
        api.post(`/CustomExtensions/exists`, model).then(
            response => {
                resolve(response.data);
            })
            .catch(error => {
                reject(error);
            });
    });
}
